import { Input, Modal, Select, Typography } from "@trustpilot/businessapp-patternlibrary";
import { HtmlText, Text, useTranslations } from "ilenia";
import { useState } from "react";

import { BaseDataResponseBody } from "../../../../types";
import { StyledFormGroup } from "../../../styled";

const roles = {
  "owner-ceo": "BusinessUserSettings.notifications.modals.your-role.roles.ownerCeo",
  marketing: "BusinessUserSettings.notifications.modals.your-role.roles.marketing",
  "customer-success": "BusinessUserSettings.notifications.modals.your-role.roles.customerSuccess",
  sales: "BusinessUserSettings.notifications.modals.your-role.roles.sales",
  "it-development": "BusinessUserSettings.notifications.modals.your-role.roles.itDevelopment",
  analyst: "BusinessUserSettings.notifications.modals.your-role.roles.analyst",
  manager: "BusinessUserSettings.notifications.modals.your-role.roles.manager",
  "communications-pr": "BusinessUserSettings.notifications.modals.your-role.roles.communicationsPr",
  other: "BusinessUserSettings.notifications.modals.your-role.roles.other",
};

const customRoleMinimumLength = 4;

export interface NotificationModalProps {
  onClose: () => void;
  onSubmit: (role: string, otherRole: string) => void;
  businessUnit: BaseDataResponseBody["businessUnit"];
}

export const YourRoleModal = (props: NotificationModalProps) => {
  const [role, setRole] = useState<string>("");
  const [customRole, setCustomRole] = useState<string>("");
  const [translations] = useTranslations();

  const requiresCustomRole = role === "other";
  const hasCustomRole = customRole.length >= customRoleMinimumLength;
  const disabledSubmission = !role || (requiresCustomRole && !hasCustomRole);

  const handleSetRole = ({ value }) => {
    setRole(value);
  };

  const handleSetCustomRole = (evt: any) => {
    setCustomRole(evt.target.value);
  };

  const handleSubmit = () => {
    props.onSubmit(role, customRole);
  };

  const options = Object.keys(roles)
    .map((key) => ({
      label: translations[roles[key]],
      value: key,
    }))
    .sort((a, b) => (a.label < b.label ? -1 : 1));

  return (
    <Modal
      isOpen
      onClose={props.onClose}
      mainActionButton={{
        buttonText: translations[`BusinessUserSettings.notifications.modals.your-role.mainActionButton`],
        disabled: disabledSubmission,
        onClick: handleSubmit,
      }}
      header={<Text id={`BusinessUserSettings.notifications.modals.your-role.header`} />}
    >
      <Typography variant="body-l">
        <p>
          <HtmlText
            id={`BusinessUserSettings.notifications.modals.your-role.body`}
            interpolations={{ COMPANY: props.businessUnit?.displayName }}
          />
        </p>
        <StyledFormGroup>
          <Select
            onChange={handleSetRole}
            options={options}
            placeholder={translations["BusinessUserSettings.notifications.modals.your-role.placeholder"]}
            value={role}
          />
        </StyledFormGroup>
        {requiresCustomRole && (
          <StyledFormGroup>
            <Input
              label={translations["BusinessUserSettings.notifications.modals.your-role.otherPleaseSpecify"]}
              value={customRole}
              onChange={handleSetCustomRole}
            />
          </StyledFormGroup>
        )}
      </Typography>
    </Modal>
  );
};
